namespace Matrix.Common {
    export interface UserPreferenceRow {
        Username?: string;
        PreferenceTypeCode?: string;
        PreferenceName?: string;
        Value?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace UserPreferenceRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'PreferenceName';
        export const localTextPrefix = 'Common.UserPreference';
        export const deletePermission = '';
        export const insertPermission = '';
        export const readPermission = '';
        export const updatePermission = '';

        export declare const enum Fields {
            Username = "Username",
            PreferenceTypeCode = "PreferenceTypeCode",
            PreferenceName = "PreferenceName",
            Value = "Value",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
